export default __webpack_public_path__ + "static/media/nishant-shrestha.f751da73.jpg";